import { useDispatch, useSelector } from 'react-redux';
import { selectCartItems } from '../../../store/cart/cart.selector';
import {
  addItemToCart,
  clearItemFromCart,
  removeItemFromCart,
} from '../../../store/cart/cart.actions';
import {
  CheckoutItemContainer,
  ImageContainer,
  Name,
  Quantity,
  Price,
  Arrow,
  Value,
  RemoveButton,
} from './checkout-item.style.jsx';

const CheckoutItem = ({ cartItem }) => {
  const dispatch = useDispatch();
  const cartItems = useSelector(selectCartItems);

  const { name, imageUrl, price, quantity } = cartItem;

  const clearItemHandler = () =>
    dispatch(clearItemFromCart(cartItems, cartItem));
  const addItemHandler = () => dispatch(addItemToCart(cartItems, cartItem));
  const removeItemHandler = () =>
    dispatch(removeItemFromCart(cartItems, cartItem));

  return (
    <CheckoutItemContainer>
      <ImageContainer>
        <img src={imageUrl} alt={`${name}`} />
      </ImageContainer>

      <Name>{name}</Name>
      <Quantity>
        <Arrow onClick={removeItemHandler}>&#10216;</Arrow>
        <Value>{quantity}</Value>
        <Arrow onClick={addItemHandler}>&#10217;</Arrow>
      </Quantity>
      <Price>${price}</Price>
      <Price>${quantity * price}</Price>

      <RemoveButton onClick={clearItemHandler}>&#10006;</RemoveButton>
    </CheckoutItemContainer>
  );
};

export default CheckoutItem;
